module.exports = __webpack_public_path__ + "static/img/cca-3.2b9e291.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contact/cca-3.png
// module id = 961
// module chunks = 0